export default __webpack_public_path__ + "0fff190ddbc0fb9621f9d8affc6e8381.png";